import { IStorageProvider } from './storage-model';

export class LocalStorage implements IStorageProvider {
  private storageKeyPrefixName: string;

  constructor(storageKeyPrefixName?) {
    this.storageKeyPrefixName = storageKeyPrefixName ? storageKeyPrefixName + '_' : '';
  }

  get(key: string): string {
    return localStorage.getItem(this.storageKeyPrefixName + key) as string;
  }
  remove(key: string): void {
    localStorage.removeItem(this.storageKeyPrefixName + key);
  }
  set(key: string, value: string): void {
    localStorage.setItem(this.storageKeyPrefixName + key, value);
  }
  clear(): void {
    localStorage.clear();
  }
}
